import React, { useEffect, useState } from "react";
import { registerDialogHost } from "../../../utils/dialogs";

const COLORS = {
  danger: "#dc2626",
  info: "#0f1b2d",
  success: "#16a34a",
  warning: "#d97706",
};

function AppDialogHost() {
  const [dialog, setDialog] = useState(null);

  useEffect(() => {
    return registerDialogHost((config) =>
      new Promise((resolve) => {
        setDialog({ ...config, resolve });
      }),
    );
  }, []);

  if (!dialog) return null;

  const color = COLORS[dialog.variant] || COLORS.info;
  const close = (value) => {
    const resolve = dialog.resolve;
    setDialog(null);
    resolve(value);
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 3000 }}>
      <div className="modal-content" style={{ maxWidth: 440, overflow: "hidden", padding: 0 }}>
        <div style={{ background: color, padding: "16px 20px", color: "#fff" }}>
          <h3 style={{ margin: 0, color: "#fff" }}>{dialog.title}</h3>
        </div>
        <div style={{ padding: 20 }}>
          <p style={{ margin: 0, color: "#475569", lineHeight: 1.55, whiteSpace: "pre-wrap" }}>
            {dialog.message}
          </p>
          <div className="modal-actions" style={{ marginTop: 22 }}>
            {dialog.type === "confirm" && (
              <button className="btn-secondary" onClick={() => close(false)}>
                {dialog.cancelLabel}
              </button>
            )}
            <button
              className={dialog.variant === "danger" ? "btn-danger" : "btn-primary"}
              onClick={() => close(true)}
            >
              {dialog.confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppDialogHost;
